<template>
    <div class="estimate-page">
        <b-navbar type="light" toggleable="md" class="shadow-sm module-navbar">
            <b-navbar-toggle target="nav_dropdown_collapse"></b-navbar-toggle>
            <b-collapse
                id="nav_dropdown_collapse"
                is-nav
                v-if="estimateDetails"
            >
                <b-navbar-nav
                    v-if="
                        profile.currentView === constant.PROFILE &&
                        profile.mode === constant.VIEW
                    "
                >
                    <b-nav-item
                        v-if="
                            _hasAccess('billing.estimate.update') &&
                            !estimateDetails.isapprove &&
                            isactiveClient
                        "
                        @click="toggleProfileMode(constant.EDIT)"
                    >
                        <i class="cus-page-white-edit"></i>Edit Estimate
                    </b-nav-item>
                    <b-nav-item-dropdown :disabled="isExporting">
                        <template slot="button-content">
                            <span>
                                <spinner v-if="isExporting" />
                                <i v-else class="cus-page-attach"></i>
                                Export
                            </span>
                        </template>
                        <b-dropdown-item
                            v-if="_hasAccess('billing.estimate.email')"
                            @click="showEmailModal()"
                        >
                            <i class="cus-email"></i>
                            Email Estimate
                        </b-dropdown-item>
                        <b-dropdown-item
                            v-if="
                                _hasAccess('billing.estimate.sms') &&
                                (_isExtensionEnabled('SMS') ||
                                    _isExtensionEnabled('2_WAY_MESSAGING'))
                            "
                            @click="openEstimateSMSModal()"
                        >
                            <i class="cus-phone"></i>Text (SMS) Estimate
                        </b-dropdown-item>
                        <b-dropdown-item
                            v-if="_hasAccess('billing.estimate.print')"
                            @click="generatePrintPdf()"
                        >
                            <i class="cus-printer"></i>
                            Print Estimate
                        </b-dropdown-item>
                    </b-nav-item-dropdown>

                    <b-nav-item
                        @click="showApproveModal()"
                        v-if="
                            _hasAccess('billing.estimate.approve') &&
                            isApprovable &&
                            isactiveClient
                        "
                    >
                        <i class="cus-accept"></i>Approve Estimate
                    </b-nav-item>

                    <b-nav-item
                        @click="showConvertModal()"
                        v-if="
                            _hasAccess('billing.estimate.convert') &&
                            isConvertable &&
                            isactiveClient
                        "
                    >
                        <i class="cus-arrow-refresh"></i>Convert to Invoice
                    </b-nav-item>

                    <b-nav-item
                        @click="duplicateEstimate()"
                        v-if="
                            _hasAccess('billing.estimate.duplicate') &&
                            isactiveClient
                        "
                    >
                        <i class="cus-page-copy"></i>Duplicate
                    </b-nav-item>

                    <b-nav-item
                        @click="confirmDelete()"
                        v-if="
                            _hasAccess('billing.estimate.delete') &&
                            isactiveClient
                        "
                    >
                        <i class="cus-delete"></i>Delete Estimate
                    </b-nav-item>

                    <!-- TODO : hide_apply_disc, hide_remove_disc for Apply & Remove Discount-->
                    <b-nav-item
                        key="APPLYDISCOUNT"
                        v-if="
                            _hasAccess('setting.discount.apply') &&
                            !estimateDetails.isapprove &&
                            !estimateDetails.hide_apply_disc
                        "
                        @click="openDiscountModal()"
                    >
                        <i class="cus-tag-blue-add"></i>Apply Discount
                    </b-nav-item>
                    <b-nav-item
                        key="REMOVEDISCOUNT"
                        v-if="
                            _hasAccess('setting.discount.apply') &&
                            !estimateDetails.isapprove &&
                            !estimateDetails.hide_remove_disc
                        "
                        @click="openRemoveDiscountModal()"
                    >
                        <i class="cus-tag-blue-delete"></i>Remove Discount
                    </b-nav-item>
                    <DropdownAppointmentStatus
                        :isInvoice="false"
                        @reload-page="refreshPage"
                    ></DropdownAppointmentStatus>
                </b-navbar-nav>
                <b-navbar-nav
                    v-else-if="
                        profile.currentView === constant.PROFILE &&
                        profile.mode === constant.EDIT &&
                        profile.isSaving
                    "
                >
                    <b-nav-item>
                        Saving...
                    </b-nav-item>
                </b-navbar-nav>
                <b-navbar-nav
                    v-else-if="
                        profile.currentView === constant.PROFILE &&
                        profile.mode === constant.EDIT &&
                        profile.isSaving === false
                    "
                >
                    <b-nav-item @click="savingCheckForm" key="EDITSAVE">
                        <i class="cus-disk"></i>Save Estimate
                    </b-nav-item>
                    <b-nav-item
                        @click="() => resetProfileState(false)"
                        key="EDITCANCEL"
                    >
                        <i class="cus-cancel"></i>Cancel
                    </b-nav-item>
                </b-navbar-nav>
            </b-collapse>
            <b-navbar-nav class="ml-auto">
                <b-nav-form
                    @click="$refs['select-billing'].focus()"
                    @contextmenu="rightClickHandler"
                    class="ml-auto"
                >
                    <vet-select-billing
                        ref="select-billing"
                        :key="'search' + searchItemKey"
                        class="mr-sm-2 w-100 search nav-search show-actions"
                    />
                </b-nav-form>
            </b-navbar-nav>
        </b-navbar>
        <router-view
            ref="routerView"
            :profileMode="profile.mode"
            @saved="saved"
            @redirect-to-dashboard="redirectToDashoard"
        ></router-view>
        <div v-if="estimateDetails">
            <modal-delete
                modal-id="modal-delete-estimate"
                :estimate="estimateDetails"
                @reload="redirectToDashoard()"
            />

            <modal-approve
                modal-ref="modal-approve-estimate"
                ref="modal-approve-estimate"
                :client="estimateDetails.client"
                :estimate="estimateDetails"
                @reload="refreshPage"
            />

            <modal-convert
                modal-ref="modal-convert-estimate"
                ref="modal-convert-estimate"
                :client="estimateDetails.client"
                :estimate="estimateDetails"
                @reload="refreshPage()"
            />

            <modal-email
                modal-ref="modal-email-estimate"
                ref="modal-email-estimate"
                :client="estimateDetails.client"
                :estimate="estimateDetails"
                @reload="refreshPage()"
                @show-loading="
                    isLoading => {
                        isExporting = isLoading;
                    }
                "
            />

            <modal-new-duplicate-estimate
                modal-id="modal-new-duplicate-estimate"
                ref="modal-new-duplicate-estimate"
            />

            <modal-apply-discount
                v-if="estimateId"
                ref="apply-discount-modal"
                modal-ref="apply-discount-modal"
                :estimate-id="estimateId"
                @reload="refreshPage('tabItems')"
            />

            <modal-remove-discount
                v-if="estimateId"
                ref="remove-discount-modal"
                modal-ref="remove-discount-modal"
                :estimate-id="estimateId"
                @reload="refreshPage('tabItems')"
            />

            <exportPrintPdf
                ref="exportPrintPdf"
                :estimate="estimateDetails"
                @show-loading="
                    isLoading => {
                        isExporting = isLoading;
                    }
                "
            />

            <estimate-send-SMS-modal ref="modal-estimate-send-sms" />
        </div>
    </div>
</template>
<style type="text/css">
.estimate-page .navbar .nav-link i[class^="cus-"] {
    margin-top: 0px !important;
    margin-right: 0.2em !important;
}
</style>
<script>
/**
 * @name EstimateDetailPageNavbar
 * @description Details page of selected Return
 * @see apps/application/views/staff/billing/invoice/estimate/navbar.php
 */

import BillingEstimateServices from "@/services/billing/billing-estimate.js";
import VetSelectBilling from "@/module/commons/vet-select-billing";
import SettingMixins from "@/mixins/settings";
import RELATIONS from "@/constants/relations.js";
import Spinner from "@/components/elements/spinner";

import ModalDelete from "@/components/billing-estimate/estimate-delete-modal";
import ModalApprove from "@/components/billing-estimate/estimate-approve-modal";
import ModalConvert from "@/components/billing-estimate/estimate-convert-modal";
import ModalEmail from "@/components/billing-estimate/estimate-email-modal";
import ModalNewDuplicateEstimate from "@/components/billing-estimate/estimate-new-duplicate-modal";
import ModalApplyDiscount from "@/components/invoice/invoice-apply-discount-modal";
import ModalRemoveDiscount from "@/components/invoice/invoice-remove-discount-modal";
import DropdownAppointmentStatus from "@/components/appointments/appointment-status-dropdown.vue";
import ScheduleHelper from "@/module/schedule/helper";

const PROFILE = "estimate";
const VIEW = "VIEW";
const EDIT = "EDIT";

export default {
    components: {
        VetSelectBilling,
        Spinner,
        ModalDelete,
        ModalApprove,
        ModalConvert,
        ModalEmail,
        ModalNewDuplicateEstimate,
        ModalApplyDiscount,
        ModalRemoveDiscount,
        DropdownAppointmentStatus,
        ExportPrintPdf: () =>
            import("@/components/billing-export/export-print-pdf.vue"),
        EstimateSendSMSModal: () =>
            import("@/components/estimate-sms/modal-estimate-send-sms")
    },
    props: {},
    mixins: [SettingMixins, ScheduleHelper],
    data() {
        return {
            searchItemKey: 0,
            searchItem: null,
            isExporting: false,
            profile: {
                currentView: "",
                mode: VIEW,
                isSaving: false
            },
            constant: {
                PROFILE,
                VIEW,
                EDIT
            }
        };
    },
    computed: {
        // isEditMode() {
        //     return this.$store.getters["returnDetails/isEditMode"];
        // },
        // theReturn() {
        //     return this.$store.getters["returnDetails/returnDetails"];
        // },
        itemCount() {
            return this.estimateDetails && this.estimateDetails.estimate_items
                ? this.estimateDetails.estimate_items.length
                : 0;
        },
        estimateId() {
            return this.estimateDetails ? this.estimateDetails.id : null;
        },
        estimateDetails() {
            return this.$store.getters["billing/estimateDetails"];
        },
        isactiveClient() {
            let client =
                this.estimateDetails && this.estimateDetails.client
                    ? this.estimateDetails.client.single_business_actor
                    : null;

            if (client) {
                return (
                    client.isactive &&
                    client.relation_type == RELATIONS.BUSINESS_ACTOR.CLIENT
                );
            }

            return true;
        },
        isApprovable() {
            return this.estimateDetails
                ? !this.estimateDetails.isapprove && this.itemCount > 0
                : false;
        },
        isConvertable() {
            return this.estimateDetails
                ? this.estimateDetails.isapprove &&
                      !this.estimateDetails.isconvert
                : false;
        }
    },
    watch: {
        async $route(to) {
            this.toggleView(to.name);
            await this.$nextTick();
            this.resetProfileState();
        }
    },
    mounted() {
        const currentRoute = this.$router.history.current.name;
        this.toggleView(currentRoute);
        this._getStatus().then(statuses => {
            this.$store.commit(
                "status",
                statuses.map(status => ({
                    ...status,
                    icon: this.statusClass(status.id)
                }))
            );
        });
    },
    destroyed() {},

    methods: {
        redirectToDashoard() {
            this.$router.push({ name: "billing_dashboard" });
        },
        toggleView(routeName) {
            // NOTE: check for direct JUMP url
            if (routeName == "direct-url-billing-estimate-profile") {
                this.profile.currentView = "estimate";
            } else {
                this.profile.currentView = routeName;
            }
        },
        toggleProfileMode(value) {
            this.profile.mode = value;
            if (value == EDIT) {
                this.$refs.routerView.resetTab();
            }
        },
        /**
         * @method resetProfileState
         * @description Reset profile mode used when change invoice profile and cancel edit
         */
        resetProfileState(clearDetails = true) {
            if (clearDetails) {
                this.estimateDetails = null;
            }
            this.profile.mode = VIEW;
            this.$store.commit("billing/setDirty", false);
            if (this.profile.currentView == this.constant.PROFILE) {
                this.$refs.routerView.resetTab();
            }
        },
        rightClickHandler(e) {
            if (e.which === 3) {
                this.$refs["select-billing"].focus();
            }
        },
        goToEdit() {
            this.reloadSettings().then(() => {
                this.$store.commit("returnDetails/setEditMode", true);
            });
        },
        cancelEdit() {
            this.$store.commit("returnDetails/setEditMode", false);
        },
        async reloadSettings() {
            return this.getBusinessSettings();
        },
        openReturnEmailModal() {
            this.$refs.returnEmailModal.open();
        },
        openDiscountModal() {
            this.$refs["apply-discount-modal"].open();
        },
        openRemoveDiscountModal() {
            this.$refs["remove-discount-modal"].open();
        },
        openReturnPost() {
            this.$refs.postModal.open(this.theReturn);
        },
        generatePrintPdf() {
            this.$refs.exportPrintPdf.init();
        },
        refreshPage(reloadTab = null) {
            this.$root.$emit("refresh-estimate-page", reloadTab);
        },
        saveEditProfile() {
            this.$refs.routerView.saveEdit();
        },
        confirmDelete() {
            this.$bvModal.show("modal-delete-estimate");
        },
        showApproveModal() {
            this.$refs["modal-approve-estimate"].open();
        },
        showConvertModal() {
            this.$refs["modal-convert-estimate"].open();
        },
        showEmailModal() {
            this.$refs["modal-email-estimate"].open();
        },
        duplicateEstimate() {
            this.$refs["modal-new-duplicate-estimate"].open(
                this.estimateDetails
            );
        },
        /////////////////
        // FLOW SAVING //
        /////////////////
        /**
         * @method savingCheckForm
         * @description Flow to save invoice edit
         * savingCheckForm(estimate.vue) -> checkFormValid(estimate.vue) -> isValid(estimate/estimate-update.vue) : Boolean
         * savingConfirmation -> open modal warning save for write off status only
         * proceedSaveEditItem
         */
        async savingCheckForm() {
            const isFormValid = await this.$refs.routerView.savingCheckFormValid();
            if (!isFormValid) {
                this.cancelSaved();
                return;
            }

            this.proceedSaveEditEstimate();
        },
        ////////////////////////
        // FLOW SAVING - EDIT //
        ////////////////////////
        /**
         * @method proceedSaveEditInvoice
         * @description Before proceed saving, the flow must check if write off status to other status.
         */
        proceedSaveEditEstimate() {
            this.profile.isSaving = true;
            this.$refs.routerView.savingEditInvoice();
        },
        /**
         * @method cancelSaved
         * @description Cancel saving and return to edit mode form
         */
        cancelSaved() {
            this.profile.isSaving = false;
            this.$store.commit("billing/setDirty", false);
        },
        /**
         * @method saved
         * @description Form has been saved
         */
        saved(result = {}) {
            this.profile.isSaving = false;
            if (result.success) {
                this.profile.mode = VIEW;
            }
        },
        async openEstimateSMSModal() {
            this.$refs["modal-estimate-send-sms"].open(this.estimateDetails.id);
        }
    }
};
</script>
